/**
 * CTA Hover Animation — Clean & Minimal
 * Replaces the previous liquid effect.
 */

document.addEventListener('DOMContentLoaded', () => {
    const ctaLinks = document.querySelectorAll('.cta-link, .text-link');

    ctaLinks.forEach((link) => {
        link.addEventListener('mouseenter', () => {
            gsap.to(link, {
                y: -3,
                duration: 0.3,
                ease: 'power2.out',
            });
        });

        link.addEventListener('mouseleave', () => {
            gsap.to(link, {
                y: 0,
                duration: 0.3,
                ease: 'power2.out',
            });
        });
    });
});
